module.exports = __webpack_public_path__ + "static/media/work-essay.33e9f8f2.png";